import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=735fd276&scoped=true&"
import script from "./Start.vue?vue&type=script&lang=js&"
export * from "./Start.vue?vue&type=script&lang=js&"
import style0 from "./Start.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Start.vue?vue&type=style&index=1&id=735fd276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735fd276",
  null
  
)

export default component.exports